import { FormHelperText, Grid, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface BasicInfoTabProps {
  seminarLessonState: any
  seminarSelected: any
  errorForm: any
  msgForm: any
  handleInputChange: (inputName: string) => (event: any) => void
}

export const BasicInfoTab = ({ seminarLessonState, seminarSelected, errorForm, msgForm, handleInputChange }: BasicInfoTabProps) => {
  const { t } = useTranslation(['global'])

  return (
    <Grid container alignItems="end" marginBottom={0} justifyContent="space-between" spacing={2}>
      <Grid item xs={6} md={5}>
        <TextField
          label={t('title')}
          fullWidth
          required
          value={seminarLessonState.title}
          error={errorForm.title}
          helperText={msgForm.title}
          InputLabelProps={{ shrink: true }}
          inputProps={{ 'data-createlesson': 'name' }}
          onChange={handleInputChange('title')}
          variant="filled"
          sx={{ marginBottom: 'auto' }}
        />
      </Grid>

      <Grid item xs={6} md={3}>
        <TextField
          label={t('seminar')}
          fullWidth
          disabled
          margin="normal"
          value={seminarSelected.title}
          error={errorForm.course}
          helperText={msgForm.course}
          onChange={handleInputChange('seminar')}
          variant="filled"
          sx={{
            '& .MuiInputBase-input.Mui-disabled': {
              color: '#808080',
              WebkitTextFillColor: '#808080'
            },
            '& .MuiInputLabel-root': {
              color: '#808080',
              fontWeight: 'bold'
            },
            color: '#111',
            fontWeight: 'bold'
          }}
        />
        <FormHelperText error={errorForm.course}>{msgForm.course}</FormHelperText>
      </Grid>

      <Grid item xs={6} md={2}>
        <TextField
          label={`${t('duration')}(Min)`}
          type="number"
          fullWidth
          required
          margin="normal"
          value={seminarLessonState.duration}
          error={errorForm.duration}
          helperText={msgForm.duration}
          onChange={handleInputChange('duration')}
          inputProps={{ 'data-createlesson': 'duration' }}
          variant="filled"
        />
        <FormHelperText error={errorForm.duration}>{msgForm.duration}</FormHelperText>
      </Grid>

      <Grid item xs={6} md={2}>
        <TextField
          label={t('order')}
          type="number"
          fullWidth
          required
          margin="normal"
          InputProps={{ inputProps: { min: 1, 'data-createlesson': 'order' } }}
          value={seminarLessonState.order}
          error={errorForm.order}
          helperText={msgForm.order}
          onChange={handleInputChange('order')}
          variant="filled"
        />
      </Grid>
    </Grid>
  )
}
